import React, {useEffect} from 'react'
import {FormattedMessage} from 'react-intl'
import {Container, Grid, GridItem, useBreakpointValue} from '@chakra-ui/react'
import useMultiSite from '../../hooks/use-multi-site'
import RecommendedProducts from '../../components/recommended-products'
import useOcapiSite from '../../hooks/useOcapiSite'
import useEffectEvent from '../../hooks/use-effect-event'
import HeaderContent from '../../components/header-content'
import PropTypes from 'prop-types'

const RecommendedProductsWrapper = ({children}) => (
    <GridItem paddingTop={10} paddingBottom={12} paddingX={{base: 4, lg: 8}}>
        {children}
    </GridItem>
)

RecommendedProductsWrapper.propTypes = {
    children: PropTypes.node
}

const ReturnOrder = () => {
    const {site, locale} = useMultiSite()
    const [language, region] = locale.id.toLowerCase().split('-')
    const itemsPerSlide = useBreakpointValue({base: 2, lg: 3, '2xl': 4})
    const {parcellabUserId, parcellabReturnOrderJS, parcellabReturnOrderCSS} = useOcapiSite()

    const onMount = useEffectEvent(() => {
        const existing = document.getElementById('pl-returns-plugin-js')
        if (!existing) {
            const script = document.createElement('script')
            script.id = 'pl-returns-plugin-js'
            script.src = parcellabReturnOrderJS
            script.async = true
            document.body.appendChild(script)

            const linkTag = document.createElement('link')
            linkTag.id = 'pl-returns-plugin-css'
            linkTag.rel = 'stylesheet'
            linkTag.href = parcellabReturnOrderCSS
            document.getElementsByTagName('head')[0].appendChild(linkTag)
        }
    })
    useEffect(() => {
        onMount()
    }, [onMount])

    return (
        <>
            <HeaderContent />
            <Container px={2} data-testid="sf-shipment-tracking">
                <Grid align={'center'}>
                    <React.Fragment>
                        <div
                            id="pl-returns-plugin"
                            data-user={parcellabUserId}
                            data-lang-code={language}
                            data-country-code={region}
                        ></div>
                    </React.Fragment>
                </Grid>
                <RecommendedProducts
                    wrapper={RecommendedProductsWrapper}
                    title={
                        <FormattedMessage
                            defaultMessage="You may also like"
                            id="recommended_products.title.you_may_also_like"
                        />
                    }
                    recommender={`HP_recom_${site.id}`}
                    itemsPerSlide={itemsPerSlide}
                />
            </Container>
        </>
    )
}

export default ReturnOrder
